import React from "react";

export function toggleHandsetRow(id) {
  var tableRows = document.querySelectorAll(".react-bs-container-body tr, .table:not(.handset-show-all) tr");
  for (var i = 0; i < tableRows.length; ++i) {
    if (tableRows[i].querySelectorAll('[data-row-id="' + id + '"]').length) {
      if (tableRows[i].className.indexOf("expandMobileDetail") !== -1) {
        tableRows[i].className = tableRows[i].className.replace(" expandMobileDetail", "");
      } else {
        tableRows[i].className += " expandMobileDetail";
      }
    }
  }
}

export function toggleHandsetColumnButton(cell, row) {
  return (
    <div data-row-id={row.id} className="mobile" onClick={() => toggleHandsetRow(row.id)}>
      <span className="glyphicon glyphicon-chevron-up" />
      <span className="glyphicon glyphicon-chevron-down" />
    </div>
  );
}
